import styled from 'styled-components';

export default styled.li`
  padding: ${(props) => props.theme.spacing()}px;
`;
